import { Controller } from "@hotwired/stimulus"

// This controller is used to periodically check the verification status of the leads that have verification status
// pending.
export default class extends Controller {
  static get targets() {
    return ["lead"]
  }

  connect() {
    setTimeout(() => {
      this.poll()
    }, 30000)
  }

  poll() {
    let leadIds = this.pendingLeadIds()

    if (leadIds.length === 0) {
      return
    }

    let headers = { "Content-Type": "application/json" }
    if (document.querySelector("meta[name='csrf-token']")) {
      headers["X-CSRF-Token"] = document.querySelector("meta[name='csrf-token']").content
    }

    // This request has no response, it will trigger the leads to push their updated verification status
    // using turbo streams
    fetch("/lead/verify", {
      method: "PUT",
      headers: headers,
      body: JSON.stringify({ lead_ids: leadIds })
    })

    setTimeout(() => {
      this.poll()
    }, 30000)
  }

  pendingLeadIds() {
    return this.leadTargets.map((target) => {
      return target.dataset.id
    })
  }
}
